// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { styles } from "@bg/App/Components/RfqRequestQuote/GroupActions";
import { linkIconStyleGenerator } from "@bg/App/SharedStyles/GeneralStyles";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.deleteGroupLink = linkIconStyleGenerator({
    icon: "Create",
    textSize: "15px",
    iconSize: 16,
    additionalTypographyCss: css`
        opacity: 0.7;
        font-weight: ${fontConfig.weight.semiBold};
        color: #131313 !important;
    `,
    additionalIconCss: css`
        color: #9c822f;
    `,
});

styles.selectSortOption = {
    cssOverrides: {
        formField: css`
            flex-direction: row;
            align-items: center;
            width: 235px;

            label {
                width: auto;
                font-weight: ${fontConfig.weight.bold};
                font-size: ${fontConfig.fontSize.small}px;
                margin-right: 8px;
                white-space: nowrap;
            }

            &&&& select:disabled {
                color: ${getColor("text.main")};
                opacity: 0.5;
            }
        `,
        formInputWrapper: css`
            margin-top: 0 !important;
        `,
        inputSelect: css`
            font-size: ${fontConfig.fontSize.small}px;
            height: 32px;
        `,
    },
};
